<template>
	<!-- Ventilatieroosters -->
	<div v-if="projectLine.product_id === 53" class="item">
		<div class="item-title">
			{{ projectLine.searchname }}
			<div class="title-detail">{{ projectLine.amount + ' ' + projectLine.unit }}</div>
		</div>
		<div v-if="hasFormData" class="input-details">
			<div class="input-container">
				<DateField id="date-input-ventilatieroosters" :disabled="isDisabled" placeholder="01-01-2022" v-model="formData.ventilatie_roosters.ventilatieroosters_date" value-format="yyyy-mm-dd" :minimum-allowed-date="minimumDate"></DateField>
				<span class="error-message" v-if="this.errors.includes('ventilatieroosters_date')">Mag niet leeg zijn</span>
			</div>
			<div class="input-container">
				<input class="input-item" type="time" name="start-time-input-ventilatieroosters-1" id="start-time-input-ventilatieroosters-1" :disabled="isDisabled" placeholder="09:00" v-model="formData.ventilatie_roosters.ventilatieroosters_start_time">
				<span class="error-message" v-if="this.errors.includes('ventilatieroosters_start_time')">Moet het formaat 00:00 zijn</span>
			</div>
			<div class="input-container">
				<input class="input-item" type="time" name="end-time-input-ventilatieroosters-1" id="end-time-input-ventilatieroosters-1" :disabled="isDisabled" placeholder="15:00" v-model="formData.ventilatie_roosters.ventilatieroosters_end_time">
				<span class="error-message" v-if="this.errors.includes('ventilatieroosters_end_time')">Moet het formaat 00:00 zijn</span>
			</div>
			<div class="input-container">
				<select class="input-item" name="user-input-ventilatieroosters-1" id="user-input-ventilatieroosters-1" :disabled="isDisabled" v-model="formData.ventilatie_roosters.ventilatieroosters_user">
					<option :value="null" disabled selected>Selecteer een bus</option>
					<option v-for="van in vans" :value="van.id">{{ van.display_name }}</option>
				</select>
				<span class="error-message" v-if="this.errors.includes('ventilatieroosters_user')">Selecteer een bus</span>
			</div>
		</div>
	</div>
	<!-- Hoogwerker -->
	<div v-else-if="projectLine.product_id === 58" class="item">
		<div class="item-title">
			{{ projectLine.searchname }}
			<div class="title-detail">{{ projectLine.amount }} {{ projectLine.unit }}</div>
		</div>
		<div v-if="hasFormData" class="input-details hoogwerker">
			<div class="row" v-if="mainFormData.main.main_date_1 != null && mainFormData.main.main_date_1 !== ''">
				<span>{{ parseDate(mainFormData.main.main_date_1) }}</span>
				<ToggleField name="date-hoogwerker-1" :enabled="!isDisabled" :checked="formData.hoogwerker.date_hoogwerker === mainFormData.main.main_date_1" @onchange="toggleHoogwerker('main', mainFormData.main.main_date_1, $event)"/>
			</div>
			<div class="row" v-if="mainFormData.main.main_date_2 != null && mainFormData.main.main_date_2 !== ''">
				<span>{{ parseDate(mainFormData.main.main_date_2) }}</span>
				<ToggleField name="date-hoogwerker-2" :enabled="!isDisabled" :checked="formData.hoogwerker.extra_date_hoogwerker === mainFormData.main.main_date_2"  @onchange="toggleHoogwerker('extra', mainFormData.main.main_date_2, $event)"/>
			</div>
			<span class="error-message" v-if="this.errors.includes('date_hoogwerker') || this.errors.includes('extra_date_hoogwerker')">Selecteer een datum</span>
		</div>
	</div>
	<!-- For main projectline -->
	<div v-else class="item">
		<div class="item-title">
			{{ projectLine.searchname }}
			<div class="title-detail">{{ projectLine.amount }} {{ projectLine.unit }}</div>
		</div>
		<div v-if="hasFormData" class="input-details">
			<div class="input-container">
				<DateField id="date-input-main-1" placeholder="01-01-2022" :disabled="isDisabled" v-model="formData.main.main_date_1" value-format="yyyy-mm-dd" @change="updateHoogwerker" :minimum-allowed-date="minimumDate"></DateField>
				<span class="error-message" v-if="this.errors.includes('main_date_1')">Mag niet leeg zijn</span>
			</div>
			<div class="input-container">
				<input class="input-item" type="time" :disabled="isDisabled" name="start-time-input-main-1" id="start-time-input-main-1" placeholder="09:00" v-model="formData.main.main_start_time_1">
				<span class="error-message" v-if="this.errors.includes('main_start_time_1')">Moet het formaat 00:00 zijn</span>
			</div>
			<div class="input-container">
				<input class="input-item" type="time" :disabled="isDisabled" name="end-time-input-main-1" id="end-time-input-main-1" placeholder="15:00" v-model="formData.main.main_end_time_1">
				<span class="error-message" v-if="this.errors.includes('main_end_time_1')">Moet het formaat 00:00 zijn</span>
			</div>
			<div class="input-container">
				<select class="input-item" name="user-input-main-1" id="user-input-main-1" :disabled="isDisabled" v-model="formData.main.main_user_1">
					<option :value="null" disabled selected>Selecteer een bus</option>
					<option v-for="van in vans" :value="van.id">{{ van.display_name }}</option>
				</select>
				<span class="error-message" v-if="this.errors.includes('main_user_1')">Selecteer een bus</span>
			</div>
			<button v-if="canAddRow" class="input-container add-row-button" type="button" @click="toggleRow"><span v-if="!isDisabled">{{ rowButtonChar }}</span></button>
		</div>
		<div v-if="isExtraRowShown === true" class="input-details">
			<div class="input-container">
				<DateField id="date-input-main-2" placeholder="01-01-2022" :disabled="isDisabled" v-model="formData.main.main_date_2" value-format="yyyy-mm-dd" @change="updateHoogwerker" :minimum-allowed-date="minimumDate"></DateField>
				<span class="error-message" v-if="this.errors.includes('main_date_2')">Mag niet leeg zijn</span>
			</div>
			<div class="input-container">
				<input class="input-item" type="time" name="start-time-input-main-2" id="start-time-input-main-2" :disabled="isDisabled" placeholder="09:00" v-model="formData.main.main_start_time_2">
				<span class="error-message" v-if="this.errors.includes('main_start_time_2')">Moet het formaat 00:00 zijn</span>
			</div>
			<div class="input-container">
				<input class="input-item" type="time" name="end-time-input-main-2" id="end-time-input-main-2" :disabled="isDisabled" placeholder="15:00" v-model="formData.main.main_end_time_2">
				<span class="error-message" v-if="this.errors.includes('main_end_time_2')">Moet het formaat 00:00 zijn</span>
			</div>
			<div class="input-container">
				<select class="input-item" name="user-input-main-2" id="user-input-main-2" :disabled="isDisabled" v-model="formData.main.main_user_2">
					<option :value="null" disabled selected>Selecteer een bus</option>
					<option v-for="van in vans" :value="van.id">{{ van.display_name }}</option>
				</select>
				<span class="error-message" v-if="this.errors.includes('main_user_2')">Selecteer een bus</span>
			</div>
			<div class="input-container add-row-button"></div>
		</div>
	</div>
</template>

<script>
import ToggleField from "./ToggleField";
import {validateNotNull, validateTime, validateNotEmptyOrEmptyString} from "../common/validators";
import DateField from "./DateField";
import moment from "moment";

export default {
	name: "ExecutionAppointmentProjectLine",
	components: {DateField, ToggleField},
	props: {
		projectLine: Object,
		index: Number,
		vans: Array,
		mainFormData: {
			type: Object,
			default: {}
		},
		isReschedule: Boolean,
		mainProject: Object,
		isMainProjectLine: Boolean,
		isSupport: {
			type: Boolean,
			default: false
		},
		isDisabled: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {
			product: '',
			hasFormData: false,
			canAddRow: false,
			isExtraRowShown: false,
			rowButtonChar: "+",
			errors: [],
			minimumDate: new Date(),

			formData: {
				ventilatie_roosters: {
					ventilatieroosters_date: "",
					ventilatieroosters_start_time: "",
					ventilatieroosters_end_time: "",
					ventilatieroosters_user: null,
				},

				hoogwerker: {
					date_hoogwerker: "",
					extra_date_hoogwerker: ""
				},

				main: {
					main_date_1: "",
					main_start_time_1: "",
					main_end_time_1: "",
					main_user_1: null
				}
			},

			formValidators: {
				ventilatie_roosters: {
					ventilatieroosters_date: validateNotEmptyOrEmptyString,
					ventilatieroosters_start_time: validateTime,
					ventilatieroosters_end_time: validateTime,
					ventilatieroosters_user: validateNotNull
				},

				hoogwerker: {
					date_hoogwerker: this.validateHoogwerker,
					extra_date_hoogwerker: this.validateHoogwerker
				},

				main: {
					main_date_1: validateNotEmptyOrEmptyString,
					main_start_time_1: validateTime,
					main_end_time_1: validateTime,
					main_user_1: validateNotNull
				}
			}
		};
	},

	methods: {
		formChanged() {
			this.$emit("formChanged", this.product, this.formData[this.product]);
			this.$forceUpdate();
		},

		updateHoogwerker() {
			if(this.mainFormData.hoogwerker.date_hoogwerker !== this.formData.main.main_date_1 && this.mainFormData.hoogwerker.date_hoogwerker !== this.formData.main.main_date_2) {
				this.mainFormData.hoogwerker.date_hoogwerker = null;
			}
			if(this.mainFormData.hoogwerker.extra_date_hoogwerker !== this.formData.main.main_date_1 && this.mainFormData.hoogwerker.extra_date_hoogwerker !== this.formData.main.main_date_2) {
				this.mainFormData.hoogwerker.extra_date_hoogwerker = null;
			}
			this.formChanged();
		},

		toggleHoogwerker(type, value, isNeeded) {
			if (type === "main") {
				this.formData.hoogwerker.date_hoogwerker = isNeeded ? value : null;
			} else if (type === "extra") {
				this.formData.hoogwerker.extra_date_hoogwerker = isNeeded ? value : null;
			}
			this.formChanged();
		},

		toggleRow() {
			if (this.isExtraRowShown === false) {
				this.formData.main = {
					...this.formData.main,
					main_date_2: "",
					main_start_time_2: "",
					main_end_time_2: "",
					main_user_2: null
				}

				this.addExtraFormData();

				this.isExtraRowShown = true;
				this.rowButtonChar = "-";
			} else {
				this.removeExtraFormData()

				this.isExtraRowShown = false;
				this.rowButtonChar = "+";
			}
		},

		validateFields() {
			const formDataObject = this.formData[this.product];
			const formValidatorObject = this.formValidators[this.product];

			const hasData = Object.values(formDataObject).some(
				(formValue) => (formValue == null || (typeof formValue === "string" && formValue.trim() === "")) === false
			);

			if (
				formValidatorObject == null ||
				(this.product === "ventilatie_roosters" && hasData === false) ||
				(this.isSupport === true && !["main"].includes(this.product) && hasData === false)
			) {
				// No validation available so it's optional, ventilatie_roosters is always optional
				return;
			}

			for (const [field, validationFunction] of Object.entries(formValidatorObject)) {
				const value = formDataObject[field];
				validationFunction(value) !== true ? this.errors.push(field) : this.removeFormErrors(field);
			}
		},

		removeFormErrors(value) {
			this.errors = this.errors.filter(error => error !== value);
		},

		getFormValues() {
			return this.formData[this.product];
		},

		addExtraFormData() {
			this.formValidators.main = {
				...this.formValidators.main,
				main_date_2: validateNotEmptyOrEmptyString,
				main_start_time_2: validateTime,
				main_end_time_2: validateTime,
				main_user_2: validateNotNull
			}
		},

		removeExtraFormData() {
			for (const [field, validationFunction] of Object.entries(this.formValidators[this.product])) {
				if (field.includes('_2')) {
					delete this.formValidators[this.product][field];
					delete this.formData[this.product][field];

					const errorIndex = this.errors.indexOf(field);
					if (errorIndex !== -1) {
						this.errors.splice(errorIndex, 1);
					}
				}
			}
		},

		hydrateFields() {
			switch(this.product) {
				case 'ventilatie_roosters':
					this.hydrateVentilatieRoosters();
					break;
				case 'hoogwerker':
					if (this.isSupport === false) {
						this.hydrateHoogwerker();
					} else {
						this.hydrateHoogwerkerForSupport();
					}
					break;
				case 'main':
					if (this.isSupport === false) {
						this.hydrateMainProject();
					} else {
						this.hydrateMainProjectForSupport();
					}
					break;
			}
		},

		hydrateVentilatieRoosters() {
			this.formData.ventilatie_roosters.ventilatieroosters_date = this.mainProject.customfield_ventilatieroostersuitvoeringdatum;
			this.formData.ventilatie_roosters.ventilatieroosters_start_time = this.mainProject.customfield_ventilatieroostersuitvoeringbegintijd2;
			this.formData.ventilatie_roosters.ventilatieroosters_end_time = this.mainProject.customfield_ventilatieroostersuitvoeringeindtijd2;
			this.formData.ventilatie_roosters.ventilatieroosters_user = this.getUserIdFromAppointmentByType('PROJECT/VENTILATIE_ROOSTERS');
		},

		hydrateHoogwerker() {
			this.formData.hoogwerker.date_hoogwerker = this.mainProject.customfield_hoogwerkeruitvoeringdatum;
			this.formData.hoogwerker.extra_date_hoogwerker = this.mainProject.additionalData ? this.mainProject.additionalData.extra_hoogwerker_date : null;
			this.formData.main.main_date_1 = this.mainProject.customfield_uitvoeringdatum;

			if (this.mainProject.customfield_extrabusuitvoeringdatum != null && this.mainProject.customfield_extrabusuitvoeringdatum !== '') {
				this.formData.main.main_date_2 = this.mainProject.customfield_extrabusuitvoeringdatum;
			}

			if (this.mainProject.customfield_hoogwerkeruitvoeringdatum === this.mainProject.customfield_extrabusuitvoeringdatum) {
				this.formData.hoogwerker.date_hoogwerker = null;
				this.formData.hoogwerker.extra_date_hoogwerker = this.mainProject.customfield_extrabusuitvoeringdatum;
			}

			this.formChanged();
		},

		hydrateHoogwerkerForSupport() {
			this.formData.hoogwerker.date_hoogwerker = this.mainProject.customfield_supporthoogwerker;
			this.formData.hoogwerker.extra_date_hoogwerker = this.mainProject.additionalData ? this.mainProject.additionalData.extra_hoogwerker_date : null;
			this.formData.main.main_date_1 = this.mainProject.customfield_uitvoeringservicedatum;

			if (this.mainProject.customfield_supportextradatum != null && this.mainProject.customfield_supportextradatum !== '') {
				this.formData.main.main_date_2 = this.mainProject.customfield_supportextradatum;
			}

			if (this.mainProject.customfield_supporthoogwerker === this.mainProject.customfield_supportextradatum) {
				this.formData.hoogwerker.date_hoogwerker = null;
				this.formData.hoogwerker.extra_date_hoogwerker = this.mainProject.customfield_supportextradatum;
			}

			this.formChanged();
		},

		hydrateMainProject() {
			this.formData.main.main_date_1 = this.mainProject.customfield_uitvoeringdatum;
			this.formData.main.main_start_time_1 = this.mainProject.customfield_begintijduitvoering2;
			this.formData.main.main_end_time_1 = this.mainProject.customfield_eindtijduitvoering2;
			this.formData.main.main_user_1 = this.getUserIdFromAppointmentByType('PROJECT/UITVOERENDE_PLOEG');

			if (this.mainProject.customfield_extrabusuitvoeringdatum != null && this.mainProject.customfield_extrabusuitvoeringdatum !== '') {
				this.formData.main.main_date_2 = this.mainProject.customfield_extrabusuitvoeringdatum;
				this.formData.main.main_start_time_2 = this.mainProject.customfield_extrabusuitvoeringbegintijd2;
				this.formData.main.main_end_time_2 = this.mainProject.customfield_extrabusuitvoeringeindtijd2;
				this.formData.main.main_user_2 = this.getUserIdFromAppointmentByType('PROJECT/UITVOERENDE_PLOEG_EXTRA');
			}

			this.formChanged();
		},

		hydrateMainProjectForSupport() {
			this.formData.main.main_date_1 = this.mainProject.customfield_uitvoeringservicedatum;
			this.formData.main.main_start_time_1 = this.mainProject.customfield_uitvoeringservicebegintijd2;
			this.formData.main.main_end_time_1 = this.mainProject.customfield_uitvoeringserviceeindtijd2;
			this.formData.main.main_user_1 = this.getUserIdFromAppointmentByType('PROJECT/UITVOERENDE_PLOEG');

			if (this.mainProject.customfield_supportextradatum != null && this.mainProject.customfield_supportextradatum !== '') {
				this.formData.main.main_date_2 = this.mainProject.customfield_supportextradatum;
				this.formData.main.main_start_time_2 = this.mainProject.customfield_supportextrabegintijd;
				this.formData.main.main_end_time_2 = this.mainProject.customfield_supportextraeindtijd;
				this.formData.main.main_user_2 = this.getUserIdFromAppointmentByType('PROJECT/UITVOERENDE_PLOEG_EXTRA');
			}

			this.formChanged();
		},

		parseDate(date) {
			if (date != null && date !== '' && date.split("-")[0].substring(0,4).length === 4) {
				date = moment(date).format('DD-MM-YYYY');
			}

			return date;
		},

		getUserIdFromAppointmentByType(type) {
			const appointment = this.mainProject.appointments.filter((appointment) => {
				return appointment.type === type;
			}).pop();

			if (appointment)  {
				return appointment.user_id;
			}

			return null;
		},

		validateHoogwerker() {
			return validateNotEmptyOrEmptyString(this.formData.hoogwerker.date_hoogwerker) || validateNotEmptyOrEmptyString(this.formData.hoogwerker.extra_date_hoogwerker);
		}
	},

	beforeMount() {
		this.hasFormData = this.isMainProjectLine || [53, 58, 77].includes(this.projectLine.product_id);
		this.canAddRow = this.isMainProjectLine;

		switch(this.projectLine.product_id) {
			case 53:
				this.product = "ventilatie_roosters";
				break;
			case 58:
				this.product = "hoogwerker";
				break;
			default:
				this.product = "main";
				break;
		}

		// In case of rescheduling with existing extra fields, make sure the rows are already rendered
		if (this.isReschedule === true && this.hasFormData === true &&
			this.mainProject.customfield_extrabusuitvoeringdatum != null && this.mainProject.customfield_extrabusuitvoeringdatum !== '') {
			this.toggleRow();
		}
	},

	mounted() {
		if (this.isReschedule === true && this.hasFormData === true) {
			this.hydrateFields();
		}
	}
}
</script>

<style scoped lang="scss">
.input-details {
	display: flex;
	flex-direction: row;
	padding-top: 1em;
	justify-content: space-between;

	.error-message {
		color: red;
	}

	.input-container {
		width: 20%;
		display: flex;
		flex-direction: column;

		> input, > select, ::v-deep > .DateField .DateField__group .TextField {
			border: 2px solid #ced6dd;
			border-radius: 5px;
			box-shadow: none;
			margin: 0 0 8px 0;
			padding: 0.5em;
			background: #FFF;
			font-size: 1rem;
		}

		::v-deep > .DateField .DateField__group .DateField__toggle {
			top: 0;
		}
	}

	.input-container.add-row-button {
		width: 3%;
		font-size: 1.8rem;
		min-width: 36px;
		height: 34px;
		border: none;
		background: #FFF;
	}
}

.input-details.hoogwerker {
	display: block;

	.row:nth-child(2) {
		margin-top: 1em;
	}

	.row {
		display: flex;
		justify-content: space-between;
		margin-left: 0;
		margin-right: 0;
		color: gray;
	}
}
</style>
